import React from 'react';
import styled from '@emotion/styled';
import { IconButton } from 'react-magma-dom';
import { COLORS, DOTTED_FOCUS } from '../../constants';
import { IPosition } from '../../types';

export const StyledEditTool = styled.div<{ bgColor: string }>`
  width: 100%;
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  background: ${({ bgColor }) => bgColor};
  position: relative;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
`;

export const StyledLabelIcon = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const StyledLabelTool = styled.div<{ coords?: IPosition }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  bottom: ${({ coords }) => (coords?.y ? `${coords?.y}px` : `0px`)};
  left: 6px;
  min-width: 182px;
  background: ${COLORS.white};
  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  position: absolute !important;
  z-index: 100;
`;
export const StyledToolLabel = styled.div<{ height?: string }>`
  display: flex;
  justify-content: start;
  box-sizing: border-box;
  align-items: center;
  font-size: 14px;
  width: 100%;
  height: ${({ height }) => (height ? height : '33px')};
  padding: 5px 0px 5px 12px;
  border-bottom: 2px solid ${COLORS.white};
  cursor: pointer;

  :hover {
    path {
      fill: ${COLORS.white};
    }
    background: ${COLORS.debianRed};
    color: ${COLORS.white};
  }

  ${DOTTED_FOCUS};
`;

export const StyledToolLabelText = styled.div`
  padding: 0 0 0 10px;
`;

export const StyledToolButton = styled(({ ...rest }) => (
  <IconButton {...rest} style={{ backgroundColor: 'transparent', outlineOffset: '-2px' }} />
))<{
  disabled?: boolean;
  withDisabledStyle?: boolean;
}>`
  ${({ disabled }) => disabled && 'pointer-events: none;'}
  opacity: ${({ disabled, withDisabledStyle }) => (disabled && withDisabledStyle ? 0.2 : 1)};
  width: 46px;
  height: 42px;
  margin: 0;
  border-radius: unset;
`;

export const StyledLabelTooltip = styled.span`
  position: absolute !important;
  left: 33.5%;
  bottom: -16px;
  border: 8px solid transparent;
  border-top: 8px solid ${COLORS.white};
`;

export const StyledDropdown = styled.div`
  display: inline-block;
`;

export const StyledDropdownContent = styled.div`
  background: ${COLORS.white};
  border-radius: 2px;
  box-shadow:
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  color: ${COLORS.blackOlive};
  display: flex;
  flex-direction: column;
  position: relative;
  width: auto;
  display: block;
  right: 50%;
  outline: 0;
  position: absolute !important;
  white-space: nowrap;
  top: auto;
  bottom: 100%;
  margin-bottom: 4px;
  z-index: 100;

  ::after {
    content: '';
    position: absolute !important;
    right: 17px;
    top: 100%;
    width: 0px;
    height: 0px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid white;
  }
`;

export const StyledDropdownMenuItem = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  padding: 10px;
  white-space: nowrap;
  position: relative;
  border-radius: 2px;

  :not(:last-child)::after {
    content: '';
    height: 1px;
    background-color: ${COLORS.gallery};
    width: calc(100% - 20px);
    position: absolute !important;
    bottom: 0;
  }

  :hover {
    background-color: ${COLORS.gallery};
  }
`;
